export const MODULE = "new/company-ui-interactions";
